import React from 'react';
import './Loader.css'; // CSS for styling

interface FullScreenLoaderProps {
  isLoading?: boolean;
  message?: string;
}

const FullScreenLoader: React.FC<FullScreenLoaderProps> = ({ isLoading = true, message }) => {
  if (!isLoading) return null;

  return (
    <div className="fullscreen-loader">
      <div className="loader-spinner"></div>
      {message && <p className="loader-message">&nbsp; &nbsp;{message}</p>}
    </div>
  );
};

export default FullScreenLoader;